'use client';
import { mapModifiers } from '@/utils/funtion';
import { Menu } from 'antd';
import CodeBlock from './CodeBlock';
import Link from 'next/link';
import { CONTACT } from '@/statics/constants';
const ApiDocModule = () => {
  const handleScrollToSection = (key: string) => {
    const sectionId = key;
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  return (
    <div className={mapModifiers('c-api-doc')}>
      <div className={mapModifiers('c-api-doc_wrapper')}>
        <div className="c-api-doc_menu">
          <Menu
            defaultSelectedKeys={['1']}
            defaultOpenKeys={['2', '3', '4']}
            mode="inline"
            inlineCollapsed={false}
            items={items}
            onClick={({ key }) => handleScrollToSection(key)}
          />
        </div>
        <div className="c-api-doc_content">
          <div className="c-api-doc_content_title">Hướng dẫn tích hợp API</div>
          <div className="c-api-doc_item" id="1">
            <div className="c-api-doc_item_content">
              <p>
                Chào mừng bạn đến với tài liệu hướng dẫn tích hợp API của
                Vietstats – nền tảng dữ liệu kinh tế, xã hội và thị trường được
                thiết kế để hỗ trợ doanh nghiệp ra quyết định nhanh chóng và
                chính xác hơn. Tài liệu này cung cấp hướng dẫn chi tiết giúp bạn
                dễ dàng tích hợp các API của Vietstats vào hệ thống của mình.
                Bao gồm:
              </p>
              <ul>
                <li>Tổng quan về hệ thống API</li>
                <li>Hướng dẫn xác thực và kết nối </li>
                <li>Mô tả chi tiết các endpoint và tham số</li>
                <li>Ví dụ request/response thực tế</li>
                <li>Các lưu ý về bảo mật và xử lý lỗi</li>
              </ul>
            </div>
          </div>
          <div className="c-api-doc_item" id="2">
            <div className="c-api-doc_item_header">
              I. Tổng quan về hệ thống API
            </div>
            <div className="c-api-doc_item_content">
              <p>
                Hệ thống API của Vietstats được xây dựng nhằm cung cấp quyền
                truy cập linh hoạt và bảo mật vào kho dữ liệu kinh tế – xã hội –
                thị trường được chuẩn hóa và cập nhật liên tục. Thông qua API,
                doanh nghiệp và nhà phát triển có thể tích hợp dữ liệu trực tiếp
                vào hệ thống nội bộ, ứng dụng web hoặc các nền tảng phân tích
                một cách nhanh chóng và hiệu quả
              </p>
              <p><strong>** NOTE: </strong>Nếu bạn cần hỗ trợ thêm trong quá trình tích hợp, vui lòng liên hệ đội ngũ kỹ thuật
                của Vietstats qua email: <Link href={`mailto:${CONTACT.EMAIL_SUPPORT}`}>{CONTACT.EMAIL_SUPPORT}</Link>
              </p>
              <div className="c-api-doc_item_content_sub" id="21">
                <div className="c-api-doc_item_content_sub_header">
                  1. Mục tiêu chính:
                </div>
                <ul>
                  <li><strong>Tự động hóa</strong> quá trình truy xuất và cập nhật dữ liệu.</li>
                  <li>
                    <strong>Tiết kiệm thời gian</strong> cho các tác vụ thu thập và xử lý dữ liệu
                    thủ công.
                  </li>
                  <li>
                    <strong>Tăng khả năng mở rộng</strong> cho các sản phẩm sử dụng dữ liệu kinh
                    tế – xã hội.
                  </li>
                </ul>
              </div>
              <div className="c-api-doc_item_content_sub" id="22">
                <div className="c-api-doc_item_content_sub_header">
                  2. Cấu trúc API
                </div>
                <p>
                  Hệ thống API Vietstats tuân thủ chuẩn RESTful, với phương thức
                  giao tiếp chủ yếu là <strong> HTTP/HTTPS</strong>, sử dụng định
                  dạng dữ liệu
                  <strong> JSON</strong> cho cả request và response.
                </p>
                <div className="c-api-doc_item_content_table">
                  <table>
                    <thead>
                      <tr>
                        <th>Thành phần</th>
                        <th>Mô tả</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Base URL</td>
                        <td>Được cung cấp khi đăng kí tích hợp</td>
                      </tr>
                      <tr>
                        <td>Method</td>
                        <td>GET</td>
                      </tr>
                      <tr>
                        <td>Format</td>
                        <td>Application/json</td>
                      </tr>
                      <tr>
                        <td>Authentication</td>
                        <td>API key (Được cấp riêng khi mua gói dịch vụ)</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="c-api-doc_item_content_sub" id="23">
                <div className="c-api-doc_item_content_sub_header">
                  3. Bảo mật & giới hạn truy cập
                </div>
                <p>
                  Tất cả các request phải được xác thực bằng API Key đi kèm
                  trong phần headers. Ngoài ra, hệ thống cũng hỗ trợ giới hạn
                  tốc độ truy cập (rate limiting) để đảm bảo tính ổn định và
                  công bằng giữa các bên sử dụng.
                </p>
              </div>
              <div className="c-api-doc_item_content_sub" id="24">
                <div className="c-api-doc_item_content_sub_header">
                  4. Ưu điểm nổi bật
                </div>
                <ul>
                  <li>Nhanh chóng, ổn định, dễ mở rộng.</li>
                  <li>Tài liệu rõ ràng, có ví dụ mẫu.</li>
                  <li>Được hỗ trợ trực tiếp bởi đội ngũ kỹ thuật Vietstats.</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="c-api-doc_item" id="3">
            <div className="c-api-doc_item_header">
              III. Hướng dẫn xác thực và kết nối
            </div>
            <div className="c-api-doc_item_content">
              <div className="c-api-doc_item_content_sub" id="31">
                <div className="c-api-doc_item_content_sub_header">
                  1. Nhận API Key
                </div>
                <p>
                  Sau khi đăng ký mua gói dịch vụ có tính năng tích hợp API, bạn
                  sẽ được Vietstats cấp một API Key. Mỗi API Key gắn liền với
                  thông tin tài khoản, giới hạn truy cập, thời gian sử dụng và
                  quyền sử dụng dữ liệu
                </p>
              </div>
              <div className="c-api-doc_item_content_sub" id="32">
                <div className="c-api-doc_item_content_sub_header">
                  2. Gửi API Key trong Header
                </div>
                <p>
                  Khi gửi request đến API, bạn cần đính kèm API Key trong phần
                  headers của HTTP request như sau:
                </p>
                <CodeBlock
                  language="http"
                  code={`Content-Type: application/json

x-api-key: your_api_key_here`}
                />
              </div>
              <div className="c-api-doc_item_content_sub" id="33">
                <div className="c-api-doc_item_content_sub_header">
                  3. Định dạng endpoint
                </div>
                <p>{`{BaseURL}/{endpoint}`}</p>
              </div>
              <div className="c-api-doc_item_content_sub" id="34">
                <div className="c-api-doc_item_content_sub_header">
                  4. Quản lý và bảo mật API Key
                </div>
                <ul>
                  <li>
                    Không chia sẻ API Key công khai (đặc biệt trên frontend hoặc
                    GitHub).
                  </li>
                  <li> Có thể yêu cầu cấp lại hoặc thu hồi nếu bị lộ.</li>
                  <li>
                    Một số hệ thống hỗ trợ tạo nhiều API Key để phân quyền theo
                    từng dịch vụ hoặc môi trường (dev, staging, production).
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="c-api-doc_item" id="4">
            <div className="c-api-doc_item_header">
              IV. Ví dụ request/response thực tế
            </div>
            <div className="c-api-doc_item_content">
              <div className="c-api-doc_item_content_sub" id="41">
                <div className="c-api-doc_item_content_sub_header">
                  1. Request
                </div>
                <CodeBlock
                  language="bash"
                  code={`curl -X GET "{BaseURL}/{endpoint}?id=G00101&is_structure=1&is_object_one_time=0&type=bar&page_size=10&page_limit=1" \-H "x-api-key: your_api_key_here"`}
                />
              </div>
              <div className="c-api-doc_item_content_sub">
                <div className="c-api-doc_item_content_sub_header">
                  Giải thích Request:
                </div>
                <div className="c-api-doc_item_content_table">
                  <table>
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Fields name</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>01</td>
                        <td>id</td>
                        <td>Id của chỉ số muốn gắn API. Được cung cấp khi đăng ký tích hợp API qua email</td>
                      </tr>
                      <tr>
                        <td>02</td>
                        <td>is_structure</td>
                        <td>Loại chỉ số, được cung cấp khi đăng ký tích hợp thông qua email</td>
                      </tr>
                      <tr>
                        <td>03</td>
                        <td>is_object_one_time</td>
                        <td>Loại chỉ số, được cung cấp khi đăng ký tích hợp thông qua email</td>
                      </tr>
                      <tr>
                        <td>04</td>
                        <td>type</td>
                        <td>Loại chỉ số, được cung cấp khi đăng ký tích hợp thông qua email</td>
                      </tr>
                      <tr>
                        <td>05</td>
                        <td>page_size</td>
                        <td>Vị trí bắt đầu của giá trị muốn trả về, bắt đầu là 1. Mặc định nếu không truyền sẽ trả về toàn bộ.</td>
                      </tr>
                      <tr>
                        <td>06</td>
                        <td>page_limit</td>
                        <td>Số lượng giá trị muốn trả về 1 lần gọi. Mặc định không truyền vào sẽ trả về toàn bộ</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
              <div className="c-api-doc_item_content_sub" id="42">
                <div className="c-api-doc_item_content_sub_header">
                  2. Response
                </div>
                <p>{`{BaseURL}/{endpoint}`}</p>
              </div>
              <div className="c-api-doc_item_content_sub">
                <div className="c-api-doc_item_content_sub_header">
                  Giải thích data Response:
                </div>
               <div className="c-api-doc_item_content_table">
                <table>
                  <thead>
                    <tr>
                      <th>No</th>
                      <th>Field name</th>
                      <th>Type</th>
                      <th>Required</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1</td>
                      <td>id</td>
                      <td>string</td>
                      <td>●</td>
                      <td>ID của chỉ số đang gọi</td>
                    </tr>
                    <tr>
                      <td>2</td>
                      <td>name</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Tên của chỉ số</td>
                    </tr>
                    <tr>
                      <td>3</td>
                      <td>unit</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Đơn vị tính của chỉ số</td>
                    </tr>
                    <tr>
                      <td>4</td>
                      <td>original</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Nguồn dữ liệu</td>
                    </tr>
                    <tr>
                      <td>5</td>
                      <td>note</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Ghi chú</td>
                    </tr>
                    <tr>
                      <td>6</td>
                      <td>summary</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Tổng quan chỉ số</td>
                    </tr>
                    <tr>
                      <td>7</td>
                      <td>dataType</td>
                      <td>string</td>
                      <td>●</td>
                      <td>Loại dữ liệu: [day, month, quarter, year]</td>
                    </tr>
                    <tr>
                      <td>8</td>
                      <td>values</td>
                      <td>Array&lt;Object&gt;</td>
                      <td></td>
                      <td>Dữ liệu của chỉ số. Nếu is_structure = 0, is_object_one_time=0</td>
                    </tr>
                    <tr>
                      <td>9</td>
                      <td className='child-1'>year</td>
                      <td>string</td>
                      <td></td>
                      <td>Năm tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>10</td>
                      <td className='child-1'>quarter</td>
                      <td>string</td>
                      <td></td>
                      <td>Quý tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>11</td>
                      <td className='child-1'>month</td>
                      <td>string</td>
                      <td></td>
                      <td>Tháng tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>12</td>
                      <td className='child-1'>day</td>
                      <td>string</td>
                      <td></td>
                      <td>Ngày tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>13</td>
                      <td className='child-1'>value</td>
                      <td>string</td>
                      <td></td>
                      <td>Giá trị của chỉ số</td>
                    </tr>
                    <tr>
                      <td>14</td>
                      <td>children</td>
                      <td>Array&lt;Object&gt;</td>
                      <td></td>
                      <td>Chỉ số con, chứa dữ liệu để làm rõ chỉ số cha. Nếu is_structure = 1, is_object_one_time=0</td>
                    </tr>
                    <tr>
                      <td>15</td>
                      <td className='child-1'>name</td>
                      <td>string</td>
                      <td></td>
                      <td>Tên của chỉ số con</td>
                    </tr>
                    <tr>
                      <td>16</td>
                      <td className='child-1'>unit</td>
                      <td>string</td>
                      <td></td>
                      <td>Đơn vị tính của chỉ số con</td>
                    </tr>
                    <tr>
                      <td>17</td>
                      <td className='child-1'>original</td>
                      <td>string</td>
                      <td></td>
                      <td>Nguồn dữ liệu</td>
                    </tr>
                    <tr>
                      <td>18</td>
                      <td className='child-1'>note</td>
                      <td>string</td>
                      <td></td>
                      <td>Ghi chú</td>
                    </tr>
                    <tr>
                      <td>19</td>
                      <td className='child-1'>summary</td>
                      <td>string</td>
                      <td></td>
                      <td>Tổng quan chỉ số con</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td className='child-1'>dataType</td>
                      <td>string</td>
                      <td></td>
                      <td>Loại dữ liệu: [day, month, quarter, year]</td>
                    </tr>
                    <tr>
                      <td>21</td>
                      <td className='child-1'>values</td>
                      <td>Array&lt;Object&gt;</td>
                      <td></td>
                      <td>Dữ liệu của chỉ số con</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td className='child-2'>year</td>
                      <td>string</td>
                      <td></td>
                      <td>Năm tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>23</td>
                      <td className='child-2'>quarter</td>
                      <td>string</td>
                      <td></td>
                      <td>Quý tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>24</td>
                      <td className='child-2'>month</td>
                      <td>string</td>
                      <td></td>
                      <td>Tháng tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>25</td>
                      <td className='child-2'>day</td>
                      <td>string</td>
                      <td></td>
                      <td>Ngày tổng hợp dữ liệu</td>
                    </tr>
                    <tr>
                      <td>26</td>
                      <td className='child-2'>value</td>
                      <td>string</td>
                      <td></td>
                      <td>Giá trị của chỉ số con</td>
                    </tr>
                    <tr>
                    <td>27</td>
                    <td>children</td>
                    <td>Array&lt;Object&gt;</td>
                    <td></td>
                    <td>Chỉ số làm rõ dữ liệu. Nếu is_structure = 0, is_object_one_time=1</td>
                  </tr>
                  <tr>
                    <td>28</td>
                    <td className='child-1'>name</td>
                    <td>string</td>
                    <td></td>
                    <td>Tên của chỉ số</td>
                  </tr>
                  <tr>
                    <td>29</td>
                    <td className='child-1'>unit</td>
                    <td>string</td>
                    <td></td>
                    <td>Đơn vị tính của chỉ số</td>
                  </tr>
                  <tr>
                    <td>30</td>
                    <td className='child-1'>original</td>
                    <td>string</td>
                    <td></td>
                    <td>Nguồn dữ liệu</td>
                  </tr>
                  <tr>
                    <td>31</td>
                    <td className='child-1'>note</td>
                    <td>string</td>
                    <td></td>
                    <td>Ghi chú</td>
                  </tr>
                  <tr>
                    <td>32</td>
                    <td className='child-1'>summary</td>
                    <td>string</td>
                    <td></td>
                    <td>Tổng quan chỉ số</td>
                  </tr>
                  <tr>
                    <td>33</td>
                    <td className='child-1'>dataType</td>
                    <td>string</td>
                    <td></td>
                    <td>Loại dữ liệu: [day, month, quarter, year]</td>
                  </tr>
                  <tr>
                    <td>34</td>
                    <td className='child-1'>child</td>
                    <td>Array&lt;Object&gt;</td>
                    <td></td>
                    <td>Chỉ số làm rõ dữ liệu</td>
                  </tr>
                  <tr>
                    <td>35</td>
                    <td className='child-2'>name</td>
                    <td>string</td>
                    <td></td>
                    <td>Tên của chỉ số</td>
                  </tr>
                  <tr>
                    <td>36</td>
                    <td className='child-2'>unit</td>
                    <td>string</td>
                    <td></td>
                    <td>Đơn vị tính của chỉ số</td>
                  </tr>
                  <tr>
                    <td>37</td>
                    <td className='child-2'>original</td>
                    <td>string</td>
                    <td></td>
                    <td>Nguồn dữ liệu</td>
                  </tr>
                  <tr>
                    <td>38</td>
                    <td className='child-2'>note</td>
                    <td>string</td>
                    <td></td>
                    <td>Ghi chú</td>
                  </tr>
                  <tr>
                    <td>39</td>
                    <td className='child-2'>summary</td>
                    <td>string</td>
                    <td></td>
                    <td>Tổng quan chỉ số</td>
                  </tr>
                  <tr>
                    <td>40</td>
                    <td className='child-2'>dataType</td>
                    <td>string</td>
                    <td></td>
                    <td>Loại dữ liệu: [day, month, quarter, year]</td>
                  </tr>
                  <tr>
                    <td>41</td>
                    <td className='child-2'>values</td>
                    <td>Array&lt;Object&gt;</td>
                    <td></td>
                    <td>Dữ liệu của chỉ số</td>
                  </tr>
                  <tr>
                    <td className='child-4'>42</td>
                    <td className='child-3'>year</td>
                    <td>string</td>
                    <td></td>
                    <td>Năm tổng hợp dữ liệu</td>
                  </tr>
                  <tr>
                    <td className='child-4'>43</td>
                    <td className='child-3'>quarter</td>
                    <td>string</td>
                    <td></td>
                    <td>Quý tổng hợp dữ liệu</td>
                  </tr>
                  <tr>
                    <td className='child-4'>44</td>
                    <td className='child-3'>month</td>
                    <td>string</td>
                    <td></td>
                    <td>Tháng tổng hợp dữ liệu</td>
                  </tr>
                  <tr>
                    <td className='child-4'>45</td>
                    <td className='child-3'>day</td>
                    <td>string</td>
                    <td></td>
                    <td>Ngày tổng hợp dữ liệu</td>
                  </tr>
                  <tr>
                    <td className='child-4'>46</td>
                    <td className='child-3'>value</td>
                    <td>string</td>
                    <td></td>
                    <td>Giá trị của chỉ số</td>
                  </tr>
                  </tbody>
                </table>
               </div>
              </div>
            </div>
          </div>

          <div className="c-api-doc_item" id="5">
            <div className="c-api-doc_item_header">V. Mã lỗi</div>
            <div className="c-api-doc_item_content">
              <div className="c-api-doc_item_content_table">
              <table>
                <thead>
                  <tr>
                    <th>Mã lỗi</th>
                    <th>Ý nghĩa</th>
                    <th>Gợi ý xử lý</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>400 Bad Request</td>
                    <td>Tham số không hợp lệ</td>
                    <td>Kiểm tra lại định dạng, kiểu dữ liệu và giá trị các tham số truyền vào.</td>
                  </tr>
                  <tr>
                    <td>401 Unauthorized</td>
                    <td>Thiếu hoặc sai API key</td>
                    <td>Thêm hoặc kiểm tra lại google-api-key trong header.</td>
                  </tr>
                  <tr>
                    <td>403 Forbidden</td>
                    <td>Không có quyền truy cập</td>
                    <td>Kiểm tra quyền truy cập với Vietstats. Có thể API key bị giới hạn quyền.</td>
                  </tr>
                  <tr>
                    <td>404 Not Found</td>
                    <td>Endpoint hoặc ID không tồn tại</td>
                    <td>Kiểm tra lại URL hoặc tham số ID.</td>
                  </tr>
                  <tr>
                    <td>429 Too Many Requests</td>
                    <td>Gọi API quá giới hạn</td>
                    <td>Chờ một khoảng thời gian rồi gọi lại. Có thể cần gọi thêm để gói API.</td>
                  </tr>
                  <tr>
                    <td>500 Internal Server Error</td>
                    <td>Lỗi hệ thống</td>
                    <td>Thử lại sau hoặc liên hệ với đội kỹ thuật Vietstats.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          </div>

          <div className="c-api-doc_item" id="6">
            <div className="c-api-doc_item_header">IV. Kết luận</div>
            <div className="c-api-doc_item_content">
              <p>
                Chúng tôi tin rằng dữ liệu không chỉ là những con số – mà là nền
                tảng để đưa ra quyết định đúng đắn, tạo nên giá trị và thúc đẩy
                sự phát triển bền vững. Với hệ thống API của Vietstats, bạn đang
                nắm trong tay một công cụ mạnh mẽ để tiếp cận, khai thác và ứng
                dụng dữ liệu một cách linh hoạt và hiệu quả. Tài liệu này được
                xây dựng nhằm đồng hành cùng bạn trong quá trình tích hợp, giúp
                đơn giản hóa các bước kỹ thuật và tối ưu thời gian triển khai.
                Chúng tôi luôn sẵn sàng hỗ trợ khi bạn cần – vì sự thành công
                của bạn cũng chính là mục tiêu mà Vietstats hướng đến. Nếu có
                bất kỳ thắc mắc, góp ý hoặc nhu cầu tùy biến nâng cao, đừng ngần
                ngại liên hệ với đội ngũ kỹ thuật của chúng tôi. Cảm ơn bạn đã
                lựa chọn Vietstats làm đối tác dữ liệu đáng tin cậy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiDocModule;

const items = [
  {
    key: '1',
    label: 'Tổng quát',
  },
  {
    key: '2',
    label: 'Tổng quát về hệ thống API',
    children: [
      { key: '21', label: 'Mục tiêu chính' },
      { key: '22', label: 'Cấu trúc API' },
      { key: '23', label: 'Bảo mật & giới hạn truy cập' },
      { key: '24', label: 'Ưu điểm nổi bật' },
    ],
  },
  {
    key: '3',
    label: 'Hướng dẫn xác thực và kết nối',
    children: [
      { key: '31', label: 'Nhận API Key' },
      { key: '32', label: 'Gửi API Key trong Header' },
      { key: '33', label: 'Định dạng endpoint' },
      { key: '34', label: 'Quản lý và bảo mật API Key' },
    ],
  },
  {
    key: '4',
    label: 'Ví dụ request/response thực tế',
    children: [
      { key: '41', label: 'Request' },
      { key: '42', label: 'Respone' },
    ],
  },
  {
    key: '5',
    label: 'Mã lỗi',
  },
  { key: '6', label: 'Kết luận' },
];
